import { connect } from 'react-redux'
import AdminUsers from './AdminUsers'
import { getUsers } from 'features/Users/Users.actions'
import { switchUser } from 'features/Auth/Auth.actions'
import { replace } from 'react-router-redux'
import { get, flow } from 'lodash'
import { reduxForm } from 'redux-form'
import showUsersSetRolesModal from 'features/Users/UsersSetRolesModal'

const stateToProps = ({ users }, { location: { query } }) => {
  const page = parseInt(query.page, 10) || 1
  const filterQuery = query.filterQuery
  const cacheKey = `page:${page}-query:${filterQuery}`
  const usersResults = {
    loading: false,
    data: [],
    numPages: 1,
    ...get(users, ['users', cacheKey]),
  }

  return {
    query,
    users: usersResults,
    page,
    cacheKey,
    filterQuery,
    initialValues: {
      filterQuery,
    },
  }
}

const dispatchToProps = {
  getUsers,
  switchUser,
  replace,
  showUsersSetRolesModal,
}

export default flow(
  reduxForm({
    form: 'adminUsers',
    enableReinitialize: true,
  }),
  connect(stateToProps, dispatchToProps)
)(AdminUsers)



// WEBPACK FOOTER //
// ./src/pages/AdminUsers/AdminUsers.container.js